import { Component, OnInit, ViewChild } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MainService as mainServiceMD } from "../../../../../md/service/main.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MainService } from "../../../../service/main.service";
import { SpinnerService } from '../../../../../shared/spinner.service'
// import { ThrowStmt } from "@angular/compiler";
declare var $: any;
import Swal from "sweetalert2";
import { session } from '../../../../../../environments/environment.session'
import { UtilityHierService } from "../../../service/utility-hier.service";
import { UtilityService } from "../../../service/utility.service";
import { Utf8EncodingService } from "src/app/md/service/utf8-encoding.service";
@Component({
  selector: 'app-utility-data-assignment',
  templateUrl: './utility-data-assignment.component.html',
  styleUrls: ['./utility-data-assignment.component.css']
})
export class UtilityDataAssignmentComponent {

  erpUser: any;
  b_acct_id: any;
  Obj: any = {};
  ActiveNode: any = [];
  allRoles: any = [];
  allComp: any;
  selectedComp: any = [];
  dataSource: any;
  role_name: any;
  role_id: any;

  displayedColumns: string[] = [
    "user_id",
    "node_cd",
    "status",
    "Roles",
    "node_path",
    "node_desc",
    "action",
  ];
  constructor(
    private tspinner: SpinnerService,
    // private utilityHierService: utilityHierService,
    private utilityHierService: UtilityHierService,
    private spinner: NgxSpinnerService,
    private mainServiceMD: mainServiceMD,
    public mainService: MainService,
    private utilityService: UtilityService,
    private utf8EncodingService:Utf8EncodingService,
  ) { }
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  module_cd: any = null;
  database_name: any = null;
  async ngOnInit() {
    this.module_cd = this.utilityService?.configObj?.module_cd;
    this.database_name = this.utilityService?.configObj?.database_name;
    console.log(this.module_cd);

    if (!this.module_cd || !this.database_name) {
      Swal.fire('INFO', 'FACING ISSUE WHILE NAVIGATING', 'info')
      window.history.back()
      return;
    }

    this.tspinner.show('', '')
    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.erpUser.b_acct_id;
    await this.getAllRoles();
    await this.getAllCurrentUserList();

    await this.getAccountUserInfo();

    await this.getcostcenters();
    await this.getAllgetDataAssigned();

    this.Obj["status"] = "ACTIVE";

    await this.filter_list();
    await this.getactivity();
    this.reset();
    this.tspinner.hide()
  }


  open_activitypopup() {
    if (this.planing_arr.length == 0) {
      this.down({}, -1);
    }
    $("#ACTHIER").modal("show");
  }


  setHierarchyNodeitem(item: any, i: any) {
    item["is_leaf"] = this.projhierobjisleaf[item["hierarchy_type"]];
    let dummy2 = [];
    for (let i = 0; i < this.planing_arr.length; i++) {
      dummy2.push(this.projhierobj[this.planing_arr[i]["hierarchy_type"]]);
    }
    this.Obj["node_cd"] =
      this.planing_arr[this.planing_arr.length - 1]["hierarchy_type"];
    this.Obj["path_desc"] = dummy2.join(" --> ");
  }
  projecthier: any = [];
  projhierobj: any = {};
  projhierobjtype: any = {};
  projhierobjtypecd: any = {};
  projhierobjisleaf: any = {};
  projhierobjlevel: any = {};
  projhierobjpath: any = {};
  async getactivity() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd;
    let resp = await this.utilityHierService.getprojectHierarchy(obj);
    if (resp["error"] == false) {
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]["lvl1_cd"] == 1) {
          resp.data[i]["lvl1_value"] = this.module_cd + "-root";
        }
      }
      console.log(resp["data"]);
      this.projecthier = resp["data"];
      for (let i = 0; i < resp["data"].length; i++) {
        let path = [];
        for (let j = 1; j < 8; j++) {
          path.push(resp["data"][i]["lvl" + j + "_value"]);
          this.projhierobj[resp["data"][i]["lvl" + j + "_cd"]] =
            resp["data"][i]["lvl" + j + "_value"];
          this.projhierobjtype[resp["data"][i]["lvl" + j + "_cd"]] =
            resp["data"][i]["lvl" + j + "_node_type"];
          this.projhierobjtypecd[resp["data"][i]["lvl" + j + "_cd"]] =
            resp["data"][i]["lvl" + j + "_cd"];
          this.projhierobjisleaf[resp["data"][i]["lvl" + j + "_cd"]] =
            resp["data"][i]["is_leaf"];
          this.projhierobjlevel[resp["data"][i]["lvl" + j + "_cd"]] = j;
          this.projhierobjpath[resp["data"][i]["lvl" + j + "_cd"]] =
            path.join("-->");
        }
      }
    } else {
      this.spinner.hide();
      Swal.fire("Error...", "Error While Getting Cost Center", "error");
    }
  }
  submit_act() {
    if (this.planing_arr[this.planing_arr.length - 1]["is_leaf"] == 0) {
      Swal.fire(
        "Error",
        "You Have Not Selected Leaf At The Last Level",
        "error"
      );
    } else {
      $("#ACTHIER").modal("hide");
    }
  }
  down(item: any, k: any) {
    console.log(this.planing_arr);
    let patharr = [];
    for (let i = 0; i < this.planing_arr.length; i++) {
      console.log(this.planing_arr[i]);

      patharr.push(this.projhierobj[this.planing_arr[i]["hierarchy_type"]]);
    }
    this.Obj["path_desc"] = patharr.join("-->");
    this.planing_arr.push({ level: k + 2, existing_heirarchy_nodes: [] });
    let arr: any = [];
    for (let i = 0; i < this.projecthier.length; i++) {
      if (!arr.includes(this.projecthier[i]["lvl" + (k + 2) + "_cd"]) && this.projecthier[i]["lvl" + (k + 2) + "_cd"] != null) {
        let a = []
        for (let m = 0; m < k; m++) {
          a.push(this.projecthier[i]["lvl" + (k + 1 - m) + "_cd"] == this.planing_arr[k - m]["hierarchy_type"])
        }
        if (a.every(value => value === true) || k == -1) {
          this.planing_arr[k + 1]["existing_heirarchy_nodes"].push({
            node_cd: this.projecthier[i]["lvl" + (k + 2) + "_cd"],
            desc: this.projecthier[i]["lvl" + (k + 2) + "_value"],
            is_leaf: this.projecthier[i]["is_leaf"],
          });
          arr.push(this.projecthier[i]["lvl" + (k + 2) + "_cd"]);
        }
      }
    }
  }
  remove(item: any, i: any) {
    if (this.planing_arr.length > 1) {
      this.planing_arr.pop();
      let patharr = [];
      for (let i = 0; i < this.planing_arr.length; i++) {
        console.log(this.planing_arr[i]);

        patharr.push(this.projhierobj[this.planing_arr[i]["hierarchy_type"]]);
      }
      this.Obj["path_desc"] = patharr.join("-->");
    }
  }
  // ***********************************Account Integration******************************************************************
  allcostcenters: any = [];
  async getcostcenters() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd;
    let resp = await this.utilityHierService.getCost(obj);
    if (resp["error"] == false) {
      this.allcostcenters = [];
      console.log(resp["data"]);
      for (let i = 0; i < resp["data"].length; i++) {
        if (resp["data"][i]["cc_func"] == this.module_cd) {
          let obb = Object.assign({}, resp["data"][i]);
          obb["node_cd"] = obb["cc_code"];
          obb["desc"] = obb["cc_code"] + "-" + obb["cc_name"];
          obb["node_desc"] = obb["desc"];
          this.allcostcenters.push(obb);
        }
      }
    } else {
      this.spinner.hide();
      Swal.fire("Error...", "Error While Getting Cost Center", "error");
    }
  }

  // ***********************************Account Integration******************************************************************
  assigned_data: any = [];
  async getAllgetDataAssigned() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["database_name"] = this.database_name;
    console.log(obj);
    var resp = await this.utilityHierService.getAllgetDataAssigned(
      JSON.stringify(obj)
    );
    console.log(resp, "all data");
    this.assigned_data = resp["data"];
    if (resp["error"] == false) {
    }
  }
  alldata: any = [];
  nodecdtopath: any = {};
  nodecdtoleve: any = {};
  nodecdtodesc: any = {};

  async filter_list() {
    let dummy: any = [];
    for (let i = 0; i < this.assigned_data.length; i++) {
      if (this.Obj["status"] == this.assigned_data[i]["status"]) {
        this.assigned_data[i]["path"] =
          this.projhierobjpath[this.assigned_data[i]["node_cd"]];
        this.assigned_data[i]["level"] =
          this.projhierobjlevel[this.assigned_data[i]["node_cd"]];
        this.assigned_data[i]["node_desc"] =
          this.projhierobj[this.assigned_data[i]["node_cd"]];
        dummy.push(this.assigned_data[i]);
      }
    }
    for (let i = 0; i < dummy.length; i++) {
      for (let j = 0; j < this.users.length; j++) {
        if (dummy[i]["user_id"] == this.users[j]["user_id"]) {
          dummy[i]["user_name"] = this.users[j]["emp_name"];
          let id = dummy[i]["user_id"];
          if (this.role_herarichy[id] != undefined)
            dummy[i]["roles"] = this.role_herarichy[id]["role_name"];
        }
      }
    }

    this.alldata = dummy;
    this.dataSource = new MatTableDataSource();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  access: any = [];
  userObj: any = {};
  users: any = [];


  async getAccountUserInfo() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    console.log(obj);
    var resp = await this.mainServiceMD.getuserforrolemapping(
      JSON.stringify(obj)
    );
    if (resp["error"] == false) {
      this.users = resp.data;
      console.log(this.users);
      for (let i = 0; i < this.users.length; i++) {
        this.userObj[this.users[i]["user_id"]] = this.users[i]["emp_name"];
        this.users[i]["desc"] =
          this.users[i]["user_id"] +
          " - " +
          this.users[i]["emp_name"] +
          " - " +
          this.users[i]["emp_phone_no"];
      }
    }
    console.log(this.userObj, "userObj");
  }
  status: any = [{ id: "ACTIVE" }, { id: "INACTIVE" }];
  lastselct: any = [];
  setHierarchyNode(item: any, i: any) {
    console.log(this.planing_arr);
    let flag = false;
    let dummy: any = [];
    for (let i = 0; i < this.planing_arr.length; i++) {
      dummy.push(this.planing_arr[i]["hierarchy_type"]);
    }
    let dummy2 = [];
    if (dummy.length > 0) {
      for (let i = 0; i < dummy.length; i++) {
        for (let j = 0; j < this.existing_heirarchy_nodes.length; j++) {
          if (dummy[i] == this.existing_heirarchy_nodes[j]["node_cd"]) {
            flag = true;
            item["level"] = this.existing_heirarchy_nodes[j]["level"];
            this.Obj["node_cd"] = this.existing_heirarchy_nodes[j]["node_cd"];
            dummy2.push(this.existing_heirarchy_nodes[j]["node_desc"]);
          }
        }
      }
    }
    if (flag == false) {
      this.Obj["node_cd"] = null;
    }
    this.Obj["path_desc"] = dummy2.join(" --> ");
    this.lastselct = dummy;
    console.log(this.lastselct);
  }
  used_nodes: any = [];
  selected_row: any = {};
  add_dropdown(data: any, index: any) {
    let flag = true;
    let obj: any = {};
    for (let i = 0; i < this.existing_heirarchy_nodes.length; i++) {
      if (
        data["hierarchy_type"] == this.existing_heirarchy_nodes[i]["node_cd"]
      ) {
        obj = Object.assign({}, this.existing_heirarchy_nodes[i]);
      }
    }
    this.selected_row = Object.assign({}, obj);
    this.selected_row["index"] = index;

    this.filter_data();
  }
  filter_data() {
    console.log(this.planing_arr);

    let dummy: any = [];
    let max_level = 0;
    for (let i = 0; i < this.existing_heirarchy_nodes.length; i++) {
      if (this.existing_heirarchy_nodes[i]["level"] >= max_level) {
        max_level = this.existing_heirarchy_nodes[i]["level"];
      }
    }

    for (let i = 0; i < this.allcostcenters.length; i++) {
      if (!this.existing_heirarchy_nodes.includes(this.allcostcenters[i]))
        this.existing_heirarchy_nodes.push(this.allcostcenters[i]);
    }
    console.log(max_level, this.selected_row, this.existing_heirarchy_nodes);
    for (let j = 1; j <= max_level; j++) {
      for (let i = 0; i < this.existing_heirarchy_nodes.length; i++) {
        let node_arr = [];
        node_arr = this.existing_heirarchy_nodes[i]["path"].split("|");
        if (node_arr.includes(this.selected_row["node_cd"])) {
          if (
            this.existing_heirarchy_nodes[i]["level"] == j &&
            this.existing_heirarchy_nodes[i]["level"] >
            this.selected_row["level"]
          ) {
            dummy.push(this.existing_heirarchy_nodes[i]);
          }
        }
      }
      if (dummy.length > 0) {
        break;
      }
    }
    this.planing_arr.push({});
    this.planing_arr[this.selected_row["index"] + 1][
      "existing_heirarchy_nodes"
    ] = [];
    this.planing_arr[this.selected_row["index"] + 1][
      "existing_heirarchy_nodes"
    ] = dummy;
    console.log(dummy, "dummy", this.planing_arr);
  }
  allRole: any = [];
  roles: any = [];
  roleObj: any = {};
  async getAllRoles() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd;
    var resp = await this.mainServiceMD.getCurrentMdRole(JSON.stringify(obj));
    console.log(resp);
    if (resp["error"] == false) {
      this.roles = [];
      this.allRole = resp.data;
      for (let i = 0; i < resp.data.length; i++) {
        if (resp.data[i]["is_system_role"] == 0) {
          this.roles.push(resp.data[i]);
        }
        this.roleObj[resp.data[i]["role_cd"]] = resp.data[i]["role_name"];
      }
    }
  }
  allUsers: any = [];
  role_herarichy: any = {};
  async getAllCurrentUserList() {
    let obj: any = new Object();
    obj["b_acct_id"] = this.b_acct_id;
    obj["module_cd"] = this.module_cd
    var resp = await this.mainServiceMD.getCurrentMdUser(JSON.stringify(obj));
    console.log(resp);
    if (resp["error"] == false) {
      this.allUsers = resp["data"];
      var emp_id: any = new Object();
      for (let i = 0; i < resp["data"].length; i++) {
        for (let j = 0; j < this.allRole.length; j++) {
          if (this.allRole[j]["role_cd"] == resp["data"][i]["role_cd"]) {
            if (emp_id[resp["data"][i]["user_id"]] == undefined) {
              resp["data"][i]["role_name"] = this.allRole[j]["role_name"];
              emp_id[resp["data"][i]["user_id"]] = resp["data"][i];
            } else {
              emp_id[resp["data"][i]["user_id"]]["role_name"] =
                emp_id[resp["data"][i]["user_id"]]["role_name"] +
                " , " +
                this.allRole[j]["role_name"];
            }
          }
        }
      }
      console.log(emp_id);
      this.role_herarichy = emp_id;
    }
  }
  serchfilter = "";
  find() {
    let l = this.planing_arr.length;

    console.log(this.alldata);
    let newdata = [];
    let len = this.alldata.length;

    for (let x = 0; x < len; x++) {
      for (let j = 0; j < this.planing_arr.length; j++) {
        if (
          this.alldata[x]["node_cd"] == this.planing_arr[j]["hierarchy_type"]
        ) {
          newdata.push(this.alldata[x]);
        }
      }
    }
    console.log(newdata);

    this.dataSource = new MatTableDataSource(newdata);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  remove_dropdown(data: any, i: any) {
    //console.log(data, i)
    if (this.planing_arr.length > 1) {
      this.planing_arr.pop();
    }
    let dummy: any = [];
    for (let i = 0; i < this.planing_arr.length; i++) {
      dummy.push(this.planing_arr[i]["hierarchy_type"]);
    }
    let dummy2 = [];
    if (dummy.length > 0) {
      for (let i = 0; i < dummy.length; i++) {
        for (let j = 0; j < this.existing_heirarchy_nodes.length; j++) {
          if (dummy[i] == this.existing_heirarchy_nodes[j]["node_cd"]) {
            this.Obj["node_cd"] = this.existing_heirarchy_nodes[j]["node_cd"];
            dummy2.push(this.existing_heirarchy_nodes[j]["node_desc"]);
          }
        }
      }
    }
    this.Obj["path_desc"] = dummy2.join(" --> ");
  }
  planing_arr: any = [{}];
  NodeCodeToNodeDesc: any = {};
  existing_heirarchy_nodes: any = [];



  async inactive(element: any) {
    this.spinner.show();
    let obj: any = Object.assign({}, element);
    obj["b_acct_id"] = this.b_acct_id;
    obj["update_user_id"] = this.erpUser.user_id;
    obj["status"] = "INACTIVE";
    obj["database_name"] = this.database_name;
    console.log(obj);
    var resp = await this.utilityHierService.updateDataAssign(obj);
    console.log(resp);
    if (resp["error"] == false) {
      this.spinner.hide();
      await this.getAllgetDataAssigned();
      this.filter_list();
      Swal.fire(
        "Success...",
        "Status Successfully Changed To Inactive",
        "success"
      );
    } else {
      this.spinner.hide();
      Swal.fire("Error...", "Error While Changing Status...", "error");
    }
  }
  async reset() {
    this.Obj = {};
    this.planing_arr = [];
    this.down({}, -1);
    this.getactivity();
    this.Obj["status"] = "ACTIVE";
    await this.filter_list();
  }


  async submit() {
    this.Obj["node_cd"] =
      this.planing_arr[this.planing_arr.length - 1]["hierarchy_type"];
    if (this.Obj["node_cd"] && this.Obj["user_id"]) {
      this.Obj["b_acct_id"] = this.b_acct_id;
      this.Obj["create_user_id"] = this.erpUser.user_id;
      this.Obj["status"] = "ACTIVE";
      this.Obj["database_name"] = this.database_name;
      console.log(this.Obj);
      var resp = await this.utilityHierService.insertDataAssign(this.Obj);
      if (resp["error"] == false) {
        this.spinner.hide();
        await this.getAllgetDataAssigned();
        Swal.fire("Success..", "Successfully Created", "success");
      } else {
        this.spinner.hide();
        Swal.fire("Error...", "Error While Assign Node..", "error");
      }
    } else {
      Swal.fire("Warning...", "Please Enter All Fields Marked As *", "warning");
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}

